"use client";

import { type ReactNode } from "react";
import { cn } from "@/lib/utils";

type GlassCardProps = {
  children: ReactNode;
  className?: string;
  /** Pour intégration dans Bento : padding interne. */
  padding?: "none" | "sm" | "md" | "lg";
};

/** Carte en glassmorphism : transparence + backdrop-blur + bordure légère. */
export function GlassCard({
  children,
  className,
  padding = "md",
}: GlassCardProps) {
  return (
    <div
      className={cn(
        "rounded-2xl border border-white/10 bg-white/5 backdrop-blur-xl",
        padding === "none" && "p-0",
        padding === "sm" && "p-4",
        padding === "md" && "p-5",
        padding === "lg" && "p-6",
        className
      )}
    >
      {children}
    </div>
  );
}
